import { render, staticRenderFns } from "./ReceiveList.vue?vue&type=template&id=43efe6a7&scoped=true"
import script from "./ReceiveList.vue?vue&type=script&lang=js"
export * from "./ReceiveList.vue?vue&type=script&lang=js"
import style0 from "./ReceiveList.vue?vue&type=style&index=0&id=43efe6a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43efe6a7",
  null
  
)

export default component.exports